import React from "react";
import { useFlags } from "launchdarkly-react-client-sdk";
import { Plan, PlanCategoryType } from "../../../@types";
import {
  useTranslate,
  planDataUtils,
  isMedicareAdvantageType,
  isMapdPlanType,
} from "../../../helpers";
import {
  shouldSuppressPlanBenefits,
  calculateYourResponsibility,
} from "../../../helpers/planHelpers";
import { $$ } from "../../../helpers/currencyUtilities";
import { AppContext } from "../../../app/store";
import { useSubSectionCaption } from "../components/helper";
import { SubSectionTable } from "./helper";

export const Deductibles: React.FunctionComponent<{ plan: Plan }> = ({
  plan,
}) => {
  const t = useTranslate();
  const { state } = React.useContext(AppContext);
  const { mctCurrentPlanYear } = useFlags();
  const suppressed = shouldSuppressPlanBenefits(plan.redactions);

  const checkSuppressed = (value: unknown) => {
    return suppressed ? t("suppressed_plan_benefit") : value;
  };

  // porting the logic from "old" overview code
  const getPdpData = () => {
    return [
      {
        label: t("plan_details.overview.deductibles.drug_deductible"),
        value: checkSuppressed(
          planDataUtils.getAnnualDrugDeductible(state, mctCurrentPlanYear, plan)
        ),
      },
    ];
  };

  const getMedicareAdvantageData = () => {
    const data = [
      {
        label: t("plan_details.overview.deductibles.health_deductible"),
        value: checkSuppressed(plan.annual_deductible),
      },
    ];

    if (plan.category === PlanCategoryType.MSA) {
      data.push(
        {
          label: t("plan_details.overview.deductibles.yearly_deposit"),
          value: checkSuppressed($$(plan.msa_annual_deposit)),
        },
        {
          label: t("plan_details.overview.deductibles.your_responsibility"),
          value: checkSuppressed(
            $$(
              calculateYourResponsibility(
                plan.annual_deductible,
                plan.msa_annual_deposit
              )
            )
          ),
        }
      );
    }
    if (isMapdPlanType(plan.plan_type)) {
      data.push({
        label: t("plan_details.overview.deductibles.drug_deductible"),
        value: checkSuppressed(
          planDataUtils.getAnnualDrugDeductible(state, mctCurrentPlanYear, plan)
        ),
      });
    }
    return data;
  };

  const deductiblesData = isMedicareAdvantageType(plan.plan_type)
    ? getMedicareAdvantageData()
    : getPdpData();

  return (
    <div>
      <SubSectionTable
        data={deductiblesData}
        caption={useSubSectionCaption(
          "plan_details.overview.deductibles",
          "plan_details.overview.deductibles.definition"
        )}
      />
    </div>
  );
};
